module.exports = __webpack_public_path__ + "static/media/i4.2a24fc15.png";